import { apiRequest } from './client';
function get(endpoint, params) {
    const search = new URLSearchParams();
    if (params) {
        for (const [k, v] of Object.entries(params)) {
            if (v !== undefined && v !== '')
                search.set(k, String(v));
        }
    }
    const q = search.toString();
    return apiRequest('GET', `${endpoint}${q ? `?${q}` : ''}`);
}
function post(endpoint, data) {
    return apiRequest('POST', endpoint, data);
}
function put(endpoint, data) {
    return apiRequest('PUT', endpoint, data);
}
function del(endpoint, data) {
    return apiRequest('DELETE', endpoint, data);
}
export const scheduleApi = {
    createItem: (req) => post('/schedule/items', req),
    updateItem: (id, item) => put(`/schedule/items/${id}`, item),
    updateStatus: (id, status, isBilled) => put(`/schedule/items/${id}/status`, { status, isBilled }),
    scheduleItem: (id, scheduleModalityId, scheduleDateTime) => put(`/schedule/items/${id}/schedule`, {
        scheduleModalityId,
        scheduleDateTime,
    }),
    getItems: (params) => get('/schedule/items', params),
    getItem: (id) => get(`/schedule/items/${id}`),
    cancelItem: (id, cancelReason) => del(`/schedule/items/${id}`, { cancelReason }),
    breakMpps: (id) => post(`/schedule/items/${id}/break-mpps`, undefined),
    getModalities: (params) => get('/schedule/modalities', params),
    saveModality: (modality) => post('/schedule/modalities', modality),
    reorderModalities: (items) => put('/schedule/modalities/reorder', items),
    getTelemedicineOptions: (params) => get('/schedule/telemedicine-options', params),
    getMppsLog: (scheduleItemId) => get(`/schedule/mpps/${scheduleItemId}/log`),
    getConfiguration: (clinicId) => get('/schedule/configuration', { clinicId }),
    updateConfiguration: (clinicId, body) => put(`/schedule/configuration?clinicId=${encodeURIComponent(clinicId)}`, body),
};
